// Was: `export const client = createEdgeSpark({ baseUrl: "...youbase.cloud" })`
// from `@edgespark/client` — YouWare's hosted SDK, gone along with YouWare.
//
// Kept the same shape (`client.api.fetch`, `client.auth.getSession`,
// `client.auth.signOut`) on purpose: ~70 files across this app call these
// directly, and matching the old shape here means none of them need to
// change. Only `client.auth.renderAuthUI` (used in one place, AppLayout.tsx)
// has no equivalent — that call site is replaced with a real <LoginForm>
// component instead (see components/auth/LoginForm.tsx), since a hosted
// widget can't come with us off YouWare.
import { authClient } from "./authClient";

const BACKEND_URL = import.meta.env.VITE_BACKEND_URL as string;

export const client = {
  auth: {
    async getSession(): Promise<any> {
      // Untyped on purpose: downstream code (AuthContext.tsx) defensively
      // handles a couple of different shapes better-auth's client can
      // return here (`{data: {user, session}}` vs a bare `{user, session}`),
      // so this shim intentionally doesn't narrow the type further.
      const result = await authClient.getSession({ query: {} });
      return result;
    },
    async signOut() {
      await authClient.signOut({});
    },
  },
  api: {
    /**
     * Same contract as before: pass a path like "/api/finance/vendors" and
     * get back a fetch Response. `credentials: 'include'` is the important
     * part — it's what makes the better-auth session cookie actually reach
     * the backend on cross-origin requests.
     */
    async fetch(path: string, options?: RequestInit): Promise<Response> {
      const url = path.startsWith("http") ? path : `${BACKEND_URL}${path}`;
      const fetchOptions: RequestInit = { ...options, credentials: "include" };
      if (fetchOptions.body && !fetchOptions.headers) {
        fetchOptions.headers = { "Content-Type": "application/json" };
      }
      return fetch(url, fetchOptions);
    },
  },
};
